.editAbility {
  gap: 2px 8px;
  grid-template-columns: 1fr 80px;
  grid-template-rows: auto auto;
  display: grid;
  grid-auto-flow: column;
  margin: 16px 0;

  > label {
    font-size: 14px;
  }

  > input[type="number"] {
    text-align: right;
    padding-right: 4px;
  }
}

.lockedName {
  margin: 8px 0;
  min-height: 44px;
  display: grid;
  grid-template-columns: 1fr 80px;
  align-items: center;

  > label {
    font-size: 14px;
    position: relative;
    background: #fff4;
    padding: 8px 16px;
    min-height: 32px;
    border-radius: 16px 0 0 16px;
    display: flex;
    align-items: center;
  }

  > input[type="number"] {
    text-align: right;
    padding-right: 4px;
  }
}

.abilityCheckboxes {
  border: none;
  padding: 0 16px;
  background: #fff4;
  margin: 8px 0;
  border-radius: 2px;
  min-height: 44px;

  > div {
    display: grid;
    grid-template-columns: 78px repeat(5, 44px);
    align-items: center;

    label {
      padding: 12px;
      border-radius: 2px;
    }
  }
}

.abilityRange {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px 12px;
  align-items: center;
  padding: 8 16px;
  background: #fff4;
  margin: 8px 0;
  min-height: 44px;

  > label {
    grid-column: span 2;
  }

  > span {
    font-size: 14px;
  }

  > input {
    cursor: ew-resize;
  }
}
